import React from 'react';
import Modal from './Modal';
import Button from './Button';

const UnsavedChangesConfirmModal = ({
    isOpen,
    onClose,
    onSave,
    onDiscard,
    isSaving = false,
    title = 'Unsaved changes',
    message = 'You have unsaved changes. What would you like to do before continuing?'
}) => (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
        <p className="text-sm text-gray-600">{message}</p>
        <div className="mt-6 flex flex-wrap justify-end gap-3">
            <Button variant="secondary" onClick={onClose} disabled={isSaving}>
                Cancel
            </Button>
            <Button variant="danger" onClick={onDiscard} disabled={isSaving}>
                Discard changes
            </Button>
            <Button variant="primary" onClick={onSave} disabled={isSaving}>
                {isSaving ? 'Saving…' : 'Save'}
            </Button>
        </div>
    </Modal>
);

export default UnsavedChangesConfirmModal;
